import { IMoney } from 'interfaces/money';
import { IOrderPaymentPlansDetail } from 'interfaces/orders';
import { formatDate } from 'services/date';
import { formatMoney } from 'services/money';
import { translateKind } from 'services/payments';

export const BOLETO_MOCK = 1;

export const INVOICE_STATUS_MAP: Record<
  string,
  'neutral' | 'success' | 'warning' | 'danger' | 'primary'
> = {
  initial: 'neutral',
  paid: 'success',
  cancelled: 'warning',
  due: 'danger',
  dealed: 'warning'
};

export const currentAmount = (
  invs: {
    id: string;
    index: number;
    amount: IMoney;
    planName?: string;
    totalAmount?: IMoney;
  }[]
) =>
  invs.reduce(
    (accumulator, currentValue) => {
      const money = currentValue.totalAmount ?? currentValue.amount;
      const sum = money.cents + accumulator.cents;

      accumulator.cents = sum;
      accumulator.currency_iso = money.currency_iso;

      return accumulator;
    },
    { cents: 0, currency_iso: 'BRL' }
  );

export const planTotalFee = (plan: IOrderPaymentPlansDetail): IMoney => {
  const totalFee = plan.invoices.reduce((sum, invoice) => {
    return sum + (invoice.total_amount.cents - invoice.amount.cents);
  }, 0);
  return { cents: totalFee, currency_iso: 'BRL' };
};

export const planTags = (plan: IOrderPaymentPlansDetail) => {
  const cAmount = currentAmount(
    plan.invoices.filter(i => i.status === 'paid')
  ) as IMoney;

  return [
    { title: 'Valor do Pedido', text: formatMoney(plan.amount) },
    { title: 'Juros e Multa', text: formatMoney(planTotalFee(plan)) },
    { title: 'Valor pago', text: formatMoney(cAmount) },
    { title: 'Qtd. Parcelas', text: plan.invoices.length },
    {
      title: 'Pagamento',
      text: plan.preferences['kind']
        ? translateKind(plan.preferences['kind'])
        : '-'
    },
    { title: 'Data inicial', text: formatDate(plan.created_at, 'DD/MM/YYYY') }
  ];
};

export const handleInvoiceFee = (
  invoice: IOrderPaymentPlansDetail['invoices'][number]
) => {
  const { fines_amount: fines, interest_amount: interest } = invoice;
  const sum = fines.cents + interest.cents;
  return sum === 0 ? '-' : formatMoney({ cents: sum, currency_iso: 'BRL' });
};

export const reduceInvoicesByStatus = (
  invoices: IOrderPaymentPlansDetail['invoices']
) => {
  return invoices.reduce((acc, invoice) => {
    const { status } = invoice;

    if (!acc[status]) {
      acc[status] = [];
    }

    acc[status].push(invoice);

    return acc;
  }, {} as Record<string, IOrderPaymentPlansDetail['invoices']>);
};
